export default __webpack_public_path__ + "static/media/King Mizo.a54265f5.png";